import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
//import { AdminHomeComponent } from './admin-home/admin-home.component';
import { UnosIzmjenaDomComponent } from './unos-izmjena-prijava-dom/unos-izmjena-dom.component';
import { HomeKreditiComponent } from './home-krediti/home-krediti.component';
import { HomeStipComponent } from './home-stip/home-stip.component';

const routes: Routes = [
  
  { path: 'loginPage', component: LoginComponent},
  { path: 'homePage', component: HomeComponent},
  { path: 'prijavaPage', component: UnosIzmjenaDomComponent},
  { path: 'homeKreditiPage', component: HomeKreditiComponent},
  { path: 'homeStipPage', component: HomeStipComponent},
  //{ path: 'adminHomePage', component: AdminHomeComponent},
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
